module.exports = __webpack_public_path__ + "img/01.93b633e0.jpg";